import templateUrl from './assign-payrolls.component.html'

export const AssignPayrollsComponent = {
    bindings: {
        page: "<",
        onAssign: "&",
        changePage: "&onChangePage",
        onUnlock: "&onUnlock"
    },
    templateUrl,
    controller: class AssignPayrollsController {
        constructor() {
        }

        $onInit() {
            this.updatePageData()
        }

        $onChanges(changesObj) {
            if (changesObj.page) {
                this.updatePageData()
            }
        }

        updatePageData() {
            this.payrolls = this.page.Entities
            this.totalEntityCount = this.page.TotalEntityCount
            this.pageNumber = this.page.PageIndex + 1
            this.pageSize = this.page.PageSize
        }

    },
    controllerAs: "vm"
}
